"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var __1 = require("../..");
var InformationIcon = function (_a) {
    var className = _a.className, toolTip = _a.toolTip, iconText = _a.iconText;
    return (react_1.default.createElement(__1.Tooltip, { content: toolTip },
        react_1.default.createElement("div", { className: className }, iconText || 'i')));
};
InformationIcon.defaultProps = {
    className: undefined,
    toolTip: undefined,
    iconText: undefined,
};
exports.default = styled_components_1.default(InformationIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  height: 12px;\n  width: 12px;\n  background: #2362a2;\n  ", "\n\n  color: #fff;\n  cursor: pointer;\n  font-size: 12px;\n"], ["\n  position: absolute;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  height: 12px;\n  width: 12px;\n  background: #2362a2;\n  ",
    "\n\n  color: #fff;\n  cursor: pointer;\n  font-size: 12px;\n"])), function (_a) {
    var type = _a.type;
    return type === 'error' && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: #fe505d;\n    "], ["\n      background-color: #fe505d;\n    "])));
});
var templateObject_1, templateObject_2;
